module.exports = __webpack_public_path__ + "static/media/menu-dots-accent.329b469a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu-dots-accent.svg
// module id = 687
// module chunks = 0